import React from "react";
import aiImage from "../../../assets/customAIDevelopmentMain1.avif";
import strategyImage from "../../../assets/customAIDevelopment.avif";
import strategyImage1 from "../../../assets/custom-AI.png";

export default function CustomAIDevelopment() {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="relative h-[60vh] sm:h-[70vh] md:h-[800px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={aiImage}
            alt="Custom AI Development"
            className="w-full h-full object-cover sm:object-contain md:object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 sm:px-6">
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
            Custom AI Development
          </h1>
          <p className="text-sm sm:text-lg md:text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed">
            Build tailored AI solutions from scratch using cutting-edge technologies
          </p>
        </div>
      </section>
      {/* Content Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
            {/* Image - Left Side */}
            <div className="flex-1 w-full">
              <img
                src={strategyImage}
                alt="Custom AI Development"
                className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Content - Right Side */}
            <div className="flex-1 w-full">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 text-[#482A7A] text-center lg:text-left">
                Custom AI Development
              </h2>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6 text-center lg:text-left">
                Build tailored AI solutions from scratch using cutting-edge technologies. Our expert team develops machine learning models, neural networks, and AI applications specifically designed for your unique business requirements.
              </p>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed text-center lg:text-left">
                From concept to deployment, we create custom AI solutions that perfectly align with your business processes and deliver exceptional performance and scalability.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Custom AI for Business Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
            {/* Content - Left Side */}
            <div className="flex-1 w-full">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 text-[#482A7A] text-center lg:text-left">
                Custom AI for Your Business
              </h2>
              <p className="text-lg sm:text-xl text-gray-600 mb-8 text-center lg:text-left">
                Safely deployed, domain specific, fine-tuned GPT solutions
              </p>
              <div className="space-y-6">
                <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed">
                  When used safely, AI can automate your manual business processes, reduce operational costs and increase work efficiency. Our tailored GPT solutions are safely deployed in your environment and fine-tuned to match your specific domain requirements.
                </p>
                <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed">
                  We start every engagement with a bespoke AI Strategy to analyse feasibility and recommend the best possible solution before moving to development.
                </p>
              </div>
            </div>

            {/* Image - Right Side */}
            <div className="flex-1 w-full">
              <img
                src={strategyImage1}
                alt="Custom AI for Business"
                className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}